import { parseSafeInt } from "Backend";
import { useParams } from "react-router";

/**
 * Convenience hook to get number versions of the URL path params
 * @param ids URL path params
 * @returns number versions of the params
 */
export function useParamNumbers<T extends string>(ids: T[] = [] as const): { [key in T]: number | undefined } {
  const params = useParams();
  const mappedIds = {} as {
    [key in T]: number | undefined;
  };
  return ids.reduce((map, id) => {
    map[id as string] = parseSafeInt(params[id]);
    return map;
  }, mappedIds);
}
